"use client";

import { useState } from "react";
import { Plus, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const galleryImages = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/esports_tournament_stage.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/esports_tournament_stage.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/esports_tournament_stage.png-wvc-sizes",
  alt: "High-intensity esports tournament stage lighting",
  caption: "Nexus · Tournament Stage",
  aspect: "aspect-square",
  span: "md:row-span-1"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/pro_player_focus.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/pro_player_focus.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/pro_player_focus.png-wvc-sizes",
  alt: "Pro player focused during a match",
  caption: "Roster · Pro Focus",
  aspect: "aspect-[3/2]",
  span: "md:row-span-1"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/gaming_setup_neon.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/gaming_setup_neon.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/gaming_setup_neon.webp-wvc-sizes",
  alt: "Futuristic gaming setup with neon cyan lighting",
  caption: "Hardware · Battle Station",
  aspect: "aspect-[4/5]",
  span: "md:row-span-2"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/victory_celebration.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/victory_celebration.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/victory_celebration.png-wvc-sizes",
  alt: "Team celebrating a tournament victory",
  caption: "Victory · Championship Win",
  aspect: "aspect-square",
  span: "md:row-span-1"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/merchandise_hoodie.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/merchandise_hoodie.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/merchandise_hoodie.png-wvc-sizes",
  alt: "Official Pixel Force team merchandise hoodie",
  caption: "Gear · Official Apparel",
  aspect: "aspect-[4/5]",
  span: "md:row-span-2"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/live_stream_overlay.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/live_stream_overlay.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/live_stream_overlay.png-wvc-sizes",
  alt: "Live stream broadcast overlay",
  caption: "Broadcast · Live Feed",
  aspect: "aspect-[3/2]",
  span: "md:row-span-1"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/community_discord_event.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/community_discord_event.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/community_discord_event.png-wvc-sizes",
  alt: "Community discord event screen",
  caption: "Community · Discord Hub",
  aspect: "aspect-[4/5]",
  span: "md:row-span-2"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/team_roster_wide.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/team_roster_wide.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/team_roster_wide.png-wvc-sizes",
  alt: "Wide shot of the professional team roster",
  caption: "Roster · Elite Squad",
  aspect: "aspect-[16/9]",
  span: "md:col-span-2"
}];
export default function TheHolodeckPreview() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="3260" id="the-holodeck-preview" className="bg-background text-foreground py-20 md:py-28 lg:py-36 px-6 md:px-10 lg:px-16">
      <div ref={ref} className="max-w-[1400px] mx-auto">
        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-16 md:mb-24">
          <div className="lg:col-span-8">
            <p className={`font-mono text-xs uppercase tracking-[0.2em] mb-8 md:mb-10 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            color: "var(--primary)"
          }}>— THE PIXEL FORCE ARCHIVE</p>
            <h2 className={`font-default font-light leading-[0.95] tracking-tight text-[clamp(2.75rem,7vw,5rem)] transition-all duration-1000 delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
              <span className="block">Digital dominance,</span>
              <span className="block md:pl-[120px] italic">forged in neon.</span>
            </h2>
          </div>
          <div className={`lg:col-span-4 lg:pt-6 transition-all duration-1000 delay-300 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <p className="font-default text-base leading-relaxed text-muted-foreground">
              Pixel Force is the command center for competitive gaming. We bridge the gap between raw skill and professional esports excellence.
            </p>
            <p className="font-default text-base leading-relaxed text-muted-foreground mt-4">
              Explore our archives of tournament victories, pro-player highlights, and the gear that defines our tactical edge.
            </p>
          </div>
        </div>

        {}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5 auto-rows-auto">
          {galleryImages.map((image, i) => <div key={i} data-index={i} className={`group relative overflow-hidden ${image.span} transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
          transitionDelay: `${400 + i * 80}ms`
        }}>
              <Button variant="ghost" className="w-full h-full p-0 hover:bg-transparent flex flex-col items-start justify-end text-left" onClick={() => setOpenIndex(i)} aria-label={`View ${image.caption}`}>
                <div className={`relative w-full overflow-hidden ${image.aspect} rounded-lg`}>
                  <img src={image.src} data-wvc-srcset={image.srcset} data-wvc-sizes={image.sizes} alt={image.alt} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.04]" style={{
                filter: "contrast(1.1) saturate(1.2)"
              }} />
                  {}
                  <div className="absolute inset-0 pointer-events-none mix-blend-multiply transition-opacity duration-700 group-hover:opacity-0" style={{
                backgroundColor: "var(--primary)",
                opacity: 0.2
              }} />
                  {}
                  <div className="absolute top-3 right-3 flex items-center gap-1.5 px-2.5 py-1 rounded-lg opacity-0 translate-y-1 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500" style={{
                backgroundColor: "var(--primary)",
                color: "var(--background)"
              }}>
                    <Plus className="w-3 h-3" />
                    <span className="font-mono text-[10px] uppercase tracking-[0.15em]">View</span>
                  </div>
                </div>
              </Button>
              <p className="font-mono text-[10px] uppercase tracking-[0.18em] mt-2 md:mt-3" style={{
            color: "var(--primary)"
          }}>
                {image.caption}
              </p>
            </div>)}
        </div>
      </div>

      {}
      <Dialog open={openIndex !== null} onOpenChange={open => !open && setOpenIndex(null)}>
        <DialogContent showCloseButton={false} className="max-w-[95vw] sm:max-w-[90vw] md:max-w-5xl p-0 border-0 bg-transparent shadow-xl">
          {openIndex !== null && <div className="relative">
              <div className="relative overflow-hidden rounded-lg" style={{
            backgroundColor: "var(--secondary)"
          }}>
                <img src={galleryImages[openIndex].src} data-wvc-srcset={galleryImages[openIndex].srcset} data-wvc-sizes={galleryImages[openIndex].sizes} alt={galleryImages[openIndex].alt} className="w-full h-auto max-h-[80vh] object-contain" />
              </div>
              <div className="flex items-center justify-between mt-4 px-1">
                <p className="font-mono text-[11px] uppercase tracking-[0.2em]" style={{
              color: "var(--primary)"
            }}>
                  {galleryImages[openIndex].caption}
                </p>
                <Button variant="ghost" size="icon" onClick={() => setOpenIndex(null)} className="hover:bg-primary/10" style={{
              color: "var(--primary)"
            }} aria-label="Close">
                  <X className="w-5 h-5" />
                </Button>
              </div>
            </div>}
        </DialogContent>
      </Dialog>

      {}
      <style>{`
        [data-slot="dialog-overlay"] {
          background-color: hsla(240, 10%, 4%, 0.95) !important;
          backdrop-filter: blur(12px);
        }
      `}</style>
    </section>;
}